<script>
    export default {
        /**
         * @type {String} Name of the application
         */
        name: 'App',

        /**
         * The component's data.
         */
        data() {
            return {
                address : {},
            };
        },

        /**
         *
         * @return 'mounted' callback
         */
        mounted(){},

        /**
         *
         * @return 'created' callback
         */
        created () {},

        methods: {
            /**
            * When the location found
            * @param {Object} addressData Data of the found location
            * @param {Object} placeResultData PlaceResult object
            * @param {String} id Input container ID
            */
            getAddressData: function getAddressData(addressData, placeResultData, id) {
                this.address = addressData;
            },
            handleError: function handleError(error) {
                console.log(error)
            },
        }
    };
</script>

<template>
    <section></section>
</template>



// WEBPACK FOOTER //
// resources/js/App.vue